import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';


import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';

import Error from 'components/Error';
import Success from 'components/Success';
import useUser from 'hooks/useUser';
import useWorkKey from 'hooks/useWorkKey';

const ManagerUserCreate = observer(() => {
    const navigate = useNavigate();
    const { managerUserCreate } = useUser();
    const workKey = useWorkKey();
    const [primary_email, setPrimaryEmail] = useState('');
    const [stripe_customer_id, setCustomerId] = useState('');
    const [recurly_account_code, setRecurlyAccountCode] = useState('');
    const [subscription_service, setSubService] = useState('')
    const [subscription_product, setSubProduct] = useState('');

    function doSave() {
        if(!workKey) return;
        if(!(stripe_customer_id || recurly_account_code)) {
            Error("Need either stripe_customer_id or recurly_account_code");
            return;
        }
        if(!primary_email) {
            Error("Please enter an email");
            return;
        }
        managerUserCreate(
            workKey,
            primary_email,
            stripe_customer_id,
            recurly_account_code,
            subscription_service,
            subscription_product
        )
            .then((user) => {
                Success("Yes!");
                navigate(`/support/user/${user.uuid}`);
            })
            .catch((e) => {
                console.log(e);
                Error("Unable to create user");
            });
    }
    return (
        <Stack m={3} spacing={2}>
            <FormControl>
                <FormLabel>Primary Email</FormLabel>
                <Input
                    value={primary_email}
                    onChange={(e) => setPrimaryEmail(e.target.value)} />
            </FormControl>
            <FormControl>
                <FormLabel>Subscription Service</FormLabel>
                <Select
                    value={subscription_service}
                    onChange={(_, value) => value && setSubService(value)}>
                    <Option value="stripe">Stripe</Option>
                    <Option value="recurly">Recurly</Option>
                </Select>
            </FormControl>
            <FormControl>
                <FormLabel>Stripe Customer ID</FormLabel>
                <Input
                    value={stripe_customer_id}
                    onChange={(e) => setCustomerId(e.target.value)} />
            </FormControl>
            <FormControl>
                <FormLabel>Recurly Account Code</FormLabel>
                <Input
                    value={recurly_account_code}
                    onChange={(e) => setRecurlyAccountCode(e.target.value)} />
            </FormControl>
            <FormControl>
                <FormLabel>Subscription Product</FormLabel>
                <Select
                    value={subscription_product}
                    onChange={(_, value) => value && setSubProduct(value)}>
                    <Option value=""></Option>
                    <Option value="dedicated">Dedicated</Option>
                    <Option value="dayones">Day Ones</Option>
                    <Option value="tasks">Tasks</Option>
                </Select>
            </FormControl>
            <Button onClick={doSave}>Create User</Button>
        </Stack>
    );
});

export default ManagerUserCreate;
